/**
 * This custom hook provides the functionality to retrieve users to be shown in the UI.
 */

import {useContext, useEffect, useState} from "react";
import {FirebaseAuthContext} from "../../../../commons/firebase/FirebaseAuthProvider";
import {useSnackbar} from "notistack";
import {useIntl} from "react-intl";

const useLoadPlaylist = (playlistKey) => {

    const [playlist, setPlaylist] = useState()
    const [loading, setLoading] = useState(true)

    const {signedInUser} = useContext(FirebaseAuthContext);
    const {enqueueSnackbar} = useSnackbar();

    // Internationalization for simple strings
    const intl = useIntl();

    // Retrieving the already existing course
    const fetchPlaylistData = async () => {
        const idToken = await signedInUser.getIdToken()
        return fetch('/reg-main/playlists/' + playlistKey + '?idToken=' + idToken)
            .then(async (data) => {
                // Throw an error including the textual status of the HTTP response code (no detailed message necessary)
                if (data.status !== 200) {
                    throw new Error((await data.json()).status)
                }

                const playlistJson = await data.json();
                setPlaylist(playlistJson)
            })
            .catch((error) => {
                enqueueSnackbar(
                    intl.formatMessage({
                        id: 'app.playlists.messages.load.playlist.error',
                        defaultMessage: 'Something went wrong while loading the playlist: {error}'
                    }, {error: error.message}), {
                        variant: 'error',
                        preventDuplicate: true,
                        autoHideDuration: 5000
                    });
            })
            .finally(() => {
                setLoading(false)
            })
    }

    useEffect(() => {
        fetchPlaylistData()
    }, [])


    return {
        loading,
        playlist
    }
}
export default useLoadPlaylist;